export default {
	// Новые с 27.10.23
	'editWithoutNotice': 'Ohne Benachrichtigungen bearbeiten',
	'editOffWithoutNotice': 'Bearbeitungsmodus deaktivieren',
	'titleSystemMessage': 'Systemnachricht',
	'partner': 'Partner',
	'lastMassages': 'Korrespondenz',
	'last50MessagesManager': 'Die letzten 50 Nachrichten, die Sie gesendet haben',
	'noLast50MessagesManager': 'Noch keine Nachrichten',
	'emailFrontSite': 'Auf der Website angegebene E-Mail-Adresse',
	'isPartnerWebsite': 'Partner-Website',
	'partners': 'Partner',
	'countWebsites': 'Anzahl der Standorte',
	'siteChatResponseTemplates': 'Chat-Vorlagen',
	'siteChatResponseTemplatesName': 'Name',
	'siteChatResponseTemplatesTemplate': 'Antworttext',
	'chatTemplates': 'Chat-Vorlagen',
	'name_ru': 'Name (Russisch)',
	'name_de': 'Name (Deutsch)',
	'emailPartner': 'Partner-Login',
	'countWebsitePartner': 'Anzahl der Standorte',
	'passPartner1': 'Neues Passwort für Partner',
	'passPartner2': 'Wiederhole das neue Passwort',
	'partnerCreateAccount': 'Zeit für die Erstellung des Partnerkontos',
	'partnerFirstName': 'Partnername',
	'partnerLastName': 'Nachname des Partners',
	'partnerWasCreatedSuccessfully': "Das Partnerkonto wurde erfolgreich erstellt",
	'stageNumberInOrder': 'Liefern',
	'fileNumbering': 'Dokument',
	'paymentStage': 'Zahlung',
	'checkYesPaymentStage': 'Erhalten',
	'checkNoPaymentStage': 'Nicht erhalten',
	'files': 'Dokumente',
	'filesAreNotUploaded': 'Dateien werden nicht hochgeladen',
	'AuthorTasks': 'Aufgaben',
	'currentMilestonesPagesCount': 'Anfangs',
	'closeOrderWithoutNotice': 'Express-Abschluss',
	'confirmActionWithoutNotice': 'Ich bestätige die Schließung',
	'youWantСloseOrderWithoutNotice': "Sie markieren die aktuelle Bestellung als erfolgreich abgeschlossen und schließen sie ab, ohne den Kunden zu benachrichtigen",
	'youSuccessСloseOrderWithoutNotice': "Die Bestellung wurde erfolgreich ohne Benachrichtigung als abgeschlossen abgeschlossen",
	'invoiceFooterTitle': "Fußzeile in Einzahlungsscheinen (PDF)",
	'noTask': "Noch keine Aufgaben",
	'MyAuthorsTasks': "Fristen",
	'taskAboutOrder': "Aufgaben",
	'noOrderTask': "Für den Auftrag liegen keine aktuellen Aufgaben vor",
	'logAboutOrder': "Geschichte",
	'noOrderComment': "Keine Bestellhistorie",
	'typeEvent': "Ereignis",
	'systemTypeEvent': "Systemereignis",
	'needAuthorPutPage': "Der Autor muss die Bühne pünktlich passieren. Seiten",
	'logInMenu': "Protokolle",
	"orderLog": {
		"NewEmailChangeClientNotAnswerToStatusProcessing": "Status \"Keine Antwort\" -> \"In Bearbeitung\", habe einen Brief von einem Kunden erhalten",
		"createNewOrderFromEmail": "Die Bestellung wurde per E-Mail erstellt",
		"createNewOrderFromSiteForm": "Die Bestellung wurde über das Formular auf der Website erstellt",
		"createNewOrderFromCRM": "Die Bestellung wurde im CRM erstellt",
		"changeStatusOrder": "Bestellstatus ändern",
		"addNewMilestone": "Hinzufügen einer neuen Phase zu einer Bestellung",
		"deleteMilestone": "Entfernen einer Phase aus einer Bestellung",
		"orderStandartCompletedWithPayout": "Standardmäßiger erfolgreicher Abschluss einer abgeschlossenen Bestellung mit Zahlungen an den Autor",
		"deleteAuthorFromOrder": "Entfernen eines Autors aus einer Bestellung",
		"appointManagerInOrder": "Ernennung eines neuen Leiters für den Auftrag",
		"managerAcceptedOrder": "Der Manager bestätigte den Eingang der Bestellung",
		"updatingOrderData":  "Bestelldetails werden aktualisiert",
		"updatingStageData": "Etappendaten aktualisieren",
		"confirmPaymentMilestone": "Der Geldeingang auf dem Konto zur Zahlung der Etappe wird bestätigt",
		"changeOrderStatusToInProgressAndAddAuthor": "-> \"In Bearbeitung\", ein neuer Autor wurde ernannt",
		"setFailedOrder": "Die Bestellung wird als fehlgeschlagen und geschlossen markiert",
		"setConfirmedOrder": "Die Bestellung wird als erfolgreich abgeschlossen und abgeschlossen markiert",
		"setNewPriceJmOrderMilestone": "Für Junior- und Mittelautoren der Bühne wurde ein neuer Preis vergeben. Neuer Tarif: ",
		"setNewPriceSOrderMilestone": "Für leitende Autoren der Bühne wurde ein neuer Preis vergeben. Neuer Tarif:",
		"moveOrderToTrash": "Die Bestellung wird in den Warenkorb verschoben und abgeschlossen",
		"addWorkTypeToOrder": "Dem Auftrag wurde eine neue Art von Arbeit hinzugefügt. Seiten: ",
		"changeOrderStatusToClientNotAnswer": "-> \"Keine Antwort\"",
		"setCloseOrderWithoutNotice": "Der Auftrag wird als erfolgreich abgeschlossen markiert und ohne Benachrichtigung des Kunden abgeschlossen",
		"sendOrderForApproval": "Die Bestellung wurde zur Genehmigung an den Kunden gesendet",
		"changeOrderStatusToWaitingPayment": "-> \"Warten auf Zahlung\"",
		"changeOrderStatusToProcessing": "-> \"In Bearbeitung\"",
		"changeOrderStatusToWaitingAuthor": "-> \"Autoren-Suche\"",
		"changeOrderStatusToInProgress": "-> \"In Bearbeitung\"",
		"changeOrderStatusToWaitingApprove": "-> \"Bestätigt\"",
		"changeOrderStatusToPatchMode": "-> \"Zum Bearbeitungsmodus\"",
		"autoDistributionOfManagersSuccess": "Automatische Zuweisung eines neuen Managers zu einem Auftrag",
		"autoDistributionOfManagersError": "Fehler beim automatischen Zuweisen eines neuen Managers",
		"noManagerInDayDutySchedule": "In der aktuellen Schicht gibt es keine Manager",
		"dubleOrderIn10Minutes": "Doppelte Bewerbung in den letzten 10 Minuten",
		"noIfInDayDutySchedule": "Es gibt keine Bedingungen für die Auswahl eines Managers",
		"noFreeOtherManagerInDayDutySchedule": "Es gibt keinen Manager im Schichtdienst, der noch nicht mit diesem Kunden zusammengearbeitet hat",
		"switchOnlineManager": "Der Manager ist wieder online",
		"switchOfflineManager": "Der Manager ging offline",
		"autoCompletionOrderAfter5Days": "Automatischer Abschluss der Bestellung nach 5 Tagen Schweigen des Kunden",
		'changeNewGeneralManager': "Neuer Geschäftsführer ernannt: ",
		'changeOrderStatusToClientNotAnswer': "-> \"Keine Antwort\" ",
		'managerEmailchangeOrderStatusToClientNotAnswer': "nach dem Brief des Managers ",
		'managerAcceptOrderchangeOrderStatusToClientNotAnswer': "nachdem der Manager die Bestellung angenommen hat ",
		'managerCreateOrderchangeOrderStatusToClientNotAnswer': "nachdem der Manager eine Bestellung erstellt hat ",
		'authorLeaveOrder': "Der Autor hat die Bestellung verlassen ",
		'authorAcceptOrder': "Der Auftrag wurde vom Autor angenommen ",
	},
	'dateTimeEvent': "Veranstaltungszeit",
	'numberOrder': "Best.-Nr.",
	"noNextManager": "---",
	"managerDutySchedule": "Dienstplan",
	"managerDutyScheduleH1": "Managers duty schedule",
	"goBack": "Geh zurück",
	"selectMultiManagersTitle": "Wählen Sie Manager aus ...",
	"doYouWantToDeleteManagerFromDay": "Sie sind dabei, einen Manager für diesen Tag aus Ihrem Zeitplan zu entfernen.",
	"tariffSchedule": "Tarifplan",
	"iAmOnline": "Ich bin online",
	"iAmOffline": "Offline",
	"changeStatusManagerTitle": "Statusänderung",
	"doYouWantStatusOfflineManager": "Sie gehen offline und nehmen keine Bestellungen mehr an",
	"doYouWantStatusOnlineManager": "Sie sind wieder online und bereit, Bestellungen anzunehmen",
	"switchOfflineManagerNotification": "Sie sind offline gegangen",
	"switchOnlineManagerNotification": "Sie sind wieder online",
	"onlineStatusManager": "Status",
	"online": "Online",
	"offline": "Offline",
	"statusFollowUp": "Status des Follow-up-Mailings",
	"allowedFollowUp": "Nachmeldungen sind erlaubt",
	"notAllowedFollowUp": "Nachverfolgungen sind deaktiviert",
	"doYouWantStatusAllowedFollowUpOrder": "Sie erlauben das Versenden von Folgenachrichten an den Kunden",
	"doYouWantStatusNotAllowedFollowUpOrder": "Sie deaktivieren das Senden von Folgenachrichten an den Client",
	"switchNotAllowedFollowUpOrderNotification": "Sie haben Folgenachrichten für den Kunden deaktiviert",
	"switchAllowedFollowUpOrderNotification": "Sie haben das Senden von Folgenachrichten für den Kunden zugelassen",
	"switchAllowedFollowUpOrder": "Follow-up-Nachrichten zur Kundenbestellung enthalten",
	"switchNotAllowedFollowUpOrder": "Folgenachrichten für eine Kundenbestellung deaktivieren",
	"authorCostPerPageH1": "Kosten für eine Seite für den Autor, in Euro",
	"allowAuthorPaymentReward": "Bestätigen Sie den Abschluss der Bühne und die Zahlung der Lizenzgebühren an den Autor?",
	'balance': "Gleichgewicht",
	'topManager': "Hauptsächlich",
	'changeGeneralManagerTitle': "Wechsel des Geschäftsführers",
	'doYouWantChangeGeneralManager': "Ernennen Sie einen neuen Geschäftsführer ",
	'rating': "Bewertung",
	'newbie': "Neuling",
	'paymentsHistoryOrders': "Rückstellungen",
	'titleDialogChangeOrderStatus': "Neuen Bestellstatus auswählen ...",
	'emailAliasManager': "E-Mail-Alias",
	'sendFromAuthor': "vom Autor",
	'uploadCompletedStage': "Laden Sie den abgeschlossenen Schritt hoch.",
	'modify': "Abschließen",
	'forRevision': "Zur Überarbeitung",
	'returnToAuthorForRevision': "Zur Überarbeitung an den Autor zurücksenden ...",
	'addCommentForAuthor': "Teilen Sie dem Autor mit, was hier geändert werden muss:",
	'changeStatusOrderToPatchModeStage': 'Sie haben die Phase erfolgreich zur Überarbeitung an den Autor gesendet',
	'waitForConfirmationJobAcceptance': "Warten Sie auf die Bestätigung der Auftragsannahme.",
	'stagePatchModeNumber': "Finalisierung",
	'editingModeEnabled': "Bearbeitungsmodus aktiviert",
	'acceptJob': "Einen Job annehmen",
	// Новые с 27.10.23

	'addTicket': "Bestellung hinzufügen",
	'addTask': "Aufgabe hinzufügen",
	'addOrderComment': "Kommentar hinzufügen",
	'noOrderComment': "Keine Kommentare zur Bestellung",
	'unknowUserRole': "Unbekannter Autor",
	'unknowUserName': "Unbekannt",
	'addOrderCommentSuccess': "Der Kommentar wurde erfolgreich zur Bestellung hinzugefügt!",
	'from': "Ab",
	'to': 'Bis zu',
	'reset': "Zurück",
	'searchByNameAndClient': "Suche nach Name/Kunde/E-Mail/Nummer",
	'save': "Speichern",
	'cancel': "Stornieren",
	'chooseDate': "Wählen Sie ein Datum aus",
	'description': "Beschreibung",
	'taskView': "Aufgabenbeschreibung",
	'date': "Datum",
	'ticket': "Auftrag",
	'setByAdmin': "Wichtig!",
	'delete': "Löschen",
	'done': "Erledigt",
	'notDone': "Nicht durchgeführt",
	'completedSuccessfully': "Erfolgreich abgeschlossen",
	'addedSuccessfully': "Erfolgreich hinzugefügt",
	'setPriceSuccessfully': "Preis erfolgreich geändert",
	'changedSuccessfully': "Erfolgreich geändert",
	'deletedSuccessfully': "Erfolgreich entfernt",
	'name': "Name",
	'subject': "Fach",
	'type': "Art",
	'pagesCount': "Seiten",
	'milestonesCount': "Lieferungen",
	'priceEuro': "Preis, €",
	'dueDate': "Abgabedatum",
	'manager': "Manager",
	'comment': "Kommentar",
	'client': "Kunde",
	'level': "Eben",
	'author': "Autor",
	'task': "Aufgaben",
	'new': "Neu",
	'clientNotAnswer': "Keine Antwort",
	'processing': "In Bearbeitung",
	'waitingPayment': "Warten auf Zahlung",
	'waitingAuthor': "Autoren-Suche",
	'inProgress': "In Bearbeitung",
	'patchMode': "Änderungen",
	'waitingApprove': "Bestätigt",
	'completed': "Erledigt",
	'failedWithPayout': "Nicht bestanden (Gebühr bezahlt)",
	'failed': "Fehlgeschlagen",
	'createOrder': "Erstellung des Auftrags",
	'newtonsLaw ': "Newtonsches Gesetz",
	'clientsPhone': "Kundentelefon",
	'clientsEmail': "E-Mail des Kunden",
	'clientsEmailSecondary': "zusätzliche Kunden-E-Mail",
	'site': "Webseite",
	'email_host': "Adresse des Posteingangsservers",
	'emailIncomingUserName': 'Anmeldung beim Posteingangsserver',
	'passIncomingEmail': 'Passwort für den Posteingangsserver',
	'emailPort': "Port des Posteingangsservers",
	'emailSecure': "Protokoll des Posteingangsservers",
	'emailOutgoingHost': "Adresse des Postausgangsservers",
	'emailOutgoingUserName': 'Anmeldung am Server für ausgehende E-Mails',
	'emailOutgoingUserPassword': 'Passwort für den Postausgangsserver',
	'emailOutgoingPort': "Port des Postausgangsservers",
	'emailOutgoingSecure': "Serverprotokoll für ausgehende E-Mails",
	'subjectArea': "Fach",
	'workType': "Art von Arbeit",
	'qualityLevel': "Qualitätslevel",
	'pagesAmount': "Seitenzahl",
	'workLanguage': "Sprache",
	'language': "Sprache",
	'loadFile': "Datei hochladen",
	'create': "Erstellen",
	'orderWasCreatedSuccessfully': "Bestellung erfolgreich erstellt",
	'order': "Auftrag",
	'currentOrderStatus': "Aktueller Auftragsstatus",
	'price': "Preis",
	'refuseWork': "Bestellung stornieren",
	'writeMessage': "Nachricht schreiben",
	'chatWithAurhor': "Autor-Chatt",
	'chatWithManager': "Manager-Chatt",
	'invitesWasSent': "Einladungen verschickt",
	'youMarkedOrderAs': "Sie haben die Bestellung markiert als",
	'confirmAction': "Aktion bestätigen",
	'checkFullPaymentStage': "Hat der Kunde den vollen Betrag erhalten?",
	'agree': "mit der Bestellung beginnen",
	'youWantToMarkOrderAs': "Markierung der Bestellung als",
	'totalWorks': "Bestellungen insgesamt",
	'currentWorks': "Laufende Bestellungen",
	'favorites': "Favoriten",
	'invite': "Einladen",
	'performersRequests': "Anfragen von Autoren",
	'select': "Wählen",
	'yourRequestsWasSentSuccessfully': "Ihre Einladungen wurden erfolgreich versendet",
	'youHaveAssignedAuthorToThisProject': "Sie haben diesem Auftrag einen Autor zugeordnet",
	'thanksWeReceivedYourRequest': "Vielen Dank, wir haben Ihre Anfrage erhalten.",
	'managerWillConfirmItSoon': "Der Manager wird es bald bestätigen",
	'pleaseWait': "Bitte warten Sie",
	'paymentDetails': "Zahlungsdetails",
	'stage': "Phase",
	'priceForClient': "Preis für den Kunden",
	'priceForJuniorAndMiddle': "Preis für Junior & Middle",
	'newPriceForJuniorAndMiddle': "Neuer Preis für Junior & Middle",
	'priceForSenior': "Preis für Senioren",
	'newPriceForSenior': "Neuer Preis für Senioren",
	'pagesAmountShort': "Seitenzahl",
	'loadPhoto': "Lade ein Foto hoch",
	'downloadChecks': "Herunterladen von Quittungen",
	'confirmPayment': "Bestätige Zahlung",
	'recommendedPaymentSum': "Vorgeschlagener Zahlungsbetrag",
	'totalPaymentSum': "Zu zahlender Gesamtbetrag",
	'lowerThanRecommendedSum': "Menge weniger als empfohlen",
	'addStage': "Stufe hinzufügen",
	'sendForApproval': "Zur Genehmigung einreichen",
	'edit': "Bearbeiten",
	'approve': "Genehmigen",
	'firstlyAddWorkTypeToOrder': "Wählen Sie die Art der Arbeit",
	'youdownloadChecksSuccessfully': "Sie haben Quittungen erfolgreich hochgeladen",
	'youConfirmedPaymentSuccessfully': "Sie haben die Zahlung erfolgreich bestätigt",
	'dataWasSentToClientForApproval': "Die Dateien wurden an den Kunden geschickt",
	'dataWasSentForApproval': "Dokument zur Genehmigung gesendet",
	'youMarkedStageAs': "Sie haben die Stufe als markiert",
	'stageWasMovedToStatus': "Auftragsstatus ändern:",
	'payRewardToAuthor': "Autorenhonorare bezahlen",
	'authorsReward': "Höhe der Gebühr",
	'pay': "auszahlen",
	'doCancel': "Stornieren",
	'indicateFailureReason': "Geben Sie den Grund für den Fehler an",
	'informationAboutOrder': "Informationen zur Bestellung",
	'editInformationAboutOrder': "Bestellung bearbeiten",
	'commentAboutOrder': "Kommentare zur Bestellung",
	'workName': "Thema",
	'clientsComment': "Kundenkommentar",
	'recommendedSumShort': "Empfohlene Menge",
	'add': "Hinzufügen",
	'attachedFiles': "Angehängte Dateien | Angehängte Datei | Angehängte Dateien | Angehängte Dokumente",
	'paymentMethod': "Zahlungsmethode",
	'filesFromAuthor': "Dateien vom Autor",
	'send': "Schicken",
	'sendAutomatically': "Automatisch versenden",
	'filesWasSentToClient': "Die Dateien wurden an den Kunden übermittelt",
	'refuse': "Stornierung des Auftrags",
	'youWantToCompleteOrder': "Abschließen der Bestellung",
	'thisActionIsIrreversible': "Diese Aktion ist unumkehrbar",
	'completeOrder': "Bestellung abschließen",
	'orderIsCompletedSuccessfully': "Bestellung erfolgreich abgeschlossen",
	'writeToManager': "Schreiben Sie an den Manager",
	'discuss': "Diskutiert",
	'creationDate': "Erstelldatum",
	'calculatedSum': "Preis",
	'includingVAT': "inklusive Mehrwertsteuer",
	'assign': "Zuweisung",
	'chooseManager': "Wählen Sie einen Manager",
	'passwordRecovery': "Passwort Wiederherstellung",
	'enterYourEmailAndWeWillSendYouNewPassword': "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen ein neues Passwort",
	'recoverPassword': "Passwort wiederherstellen",
	'toLoginPage': "Zur Anmeldeseite",
	'newPasswordIsGeneratedAndSentToMail': "Neues Passwort an E-Mail gesendet",
	'registration': "Anmeldung",
	'fillFormBelowToCreateNewAccount': "Füllen Sie das folgende Formular aus, um ein neues Konto zu erstellen",
	'youAreAlreadyLoggedIn': "Du bist bereits eingeloggt!",
	'entrance': "Eingang",
	'welcomeBack': "Willkommen zurück",
	'pleaseLoginToYourAccount': "Bitte loggen Sie sich in Ihren Account ein",
	'password': "Passwort",
	'repeatPassword': "Wiederholen Sie das Passwort",
	'newPassword': "Neues Passwort",
	'yes': "Ja",
	'no': "Nein",
	'confirmDeletion': "Löschung bestätigen",
	'doYouWantToDelete': "löschen",
	'registrationLinkCreation': "Erstellen Sie einen Registrierungslink",
	'linkToRegistrationForm': "Link zum Anmeldeformular",
	'generate': "Generieren",
	'close': "schließen",
	'nickname': "Spitzname",
	'emailForPayment': "SEPA IBAN / Transferwise-Email",
	'phone': "Telefon",
	'sex': "Geschlecht",
	'country': "Land",
	'birthDate': "Geburtsdatum",
	'surname': "Nachname",
	'profile': "Profil",
	'subjects': "Fächer",
	'aboutYourself': "Über mich",
	'dataIsSaved': "Daten gespeichert",
	'totalOrdersCount': "Gesamtzahl der Bestellungen",
	'success': "Erfolg",
	'personName': "Name",
	'otherCustomerProfiles': "Andere Profile",
	'changeWorkType': "Änderung der Art der Arbeit",
	'shortRussian': "rus",
	'shortGerman': "deutsch",
	'totalTicketsAmount': "Gesamtzahl der Bestellungen",
	'activatedTickets': "Aktive Bestellungen",
	'income': "Einkommen",
	'totalIncome': "Gesamteinkommen",
	'clientEditing': "Bearbeiten eines Kunden",
	'additionalEmail': "Zusätzliche E-Mail",
	'activatedOrder': "Aktive Bestellungen",
	'changingManagerRequest': "Anfrage des Managers ändern",
	'newManager': "Neuer Manager",
	'confirm': "Bestätigen",
	'decline': "Ablehnen",
	'firstlySelectManager': "Sie müssen zuerst den Manager angeben",
	'changingManagerRequestIsSent': "Anfrage an Manager gesendet",
	'requestWasDeclined': "Anfrage wurde storniert",
	'searchByName': "Suche mit Name",
	'actions': "Aktionen",
	'totalOrders': "Bestellungen insgesamt",
	'paidOrder': "Bezahlt",
	'hangingOrders': 'Aufgehängte',
	'sitesPreferences': "Website-Einstellungen",
	'managerEditing': "Manager-Bearbeitung",
	'managerCreating': "Erstellen eines Managers",
	'sitesSettings': "Seiteneinstellungen",
	'basicPrices': "Grundpreise",
	'workTypesVisibility': "Sichtbarkeit des Arbeitstyps",
	'invoicesData': "Daten für Rechnungen",
	'siteAutoEmailAnswer': "Automatische Antworten",
	'siteAutoEmailName': "Fall",
	'siteAutoEmailDialogTitile': "Ändern Sie die automatische Antwort der Site",
	'siteChatResponseDialogTitile': "Website-Chat-Vorlage ändern",
	'siteAutoEmailTemplate': "Text des Briefes",
	'siteAutoEmailLetterSubject': "E-Mail-Betreff (bis zu 255 Zeichen)",
	'siteAutoEmailTemplateSuccess': "Der Antworttext für die Website wurde aktualisiert!",
	'siteAutoEmailParameter': "Mögliche Substitutionsmöglichkeiten",
	'changesIsSavedSuccessfully': "Änderungen erfolgreich gespeichert",
	'siteWasCreatedSuccessfully': "Website wurde erfolgreich erstellt",
	'managersFee': "Managergebühr, % der Bestellung",
	'managersGeneralFee': "General Manager-Gebühr, % der Bestellung",
	'deleteLogo': "Logo entfernen",
	'firmInfo': "Firmeninformation",
	'termsAndConditions': "Geschäftsbedingungen",
	'part': "teil",
	'addPresentationPdf': "Hinzufügen einer Site-Präsentation",
	'deletePresentationPdf': "Präsentation löschen",
	'changePresentationPdf': "Präsentation ersetzen",
	'changeLogo': "Logo ändern",
	'mainColor': "Hauptfarbe",
	'additionalColor': "Komplementärfarbe",
	'showForJunior': "Show für Junioren",
	'showForMiddle': "Show für Mitte",
	'showForSenior': "Show für Senioren",
	'general': "Allgemein",
	'bySites': "Nach Websites",
	'openDiscuss': "Offener Fall",
	'opened': "offen",
	'number': "Nummer",
	'discussTheme': "Thema",
	'status': "Status",
	'lastAnswer': "Letzte Antwort",
	'answerReceived': "Antwort erhalten",
	'waitingToAnswer': "Bitte um Antwort",
	'closed': "Geschlossen",
	'isClosed': "Geschlossen",
	'openNewDiscuss': "Neuen Fall eröffnen",
	'discussText': "Beschwerdetext",
	'doYouWantToCloseDiscuss': "Sie sind dabei, den Einspruch zu schließen",
	'closeDiscuss': "Appell schließen",
	'aDiscuss': "Appellieren",
	'discussStatus': "Bewerbungsstatus",
	'write': "Schreiben",
	'techSupport': "Technischer Support",
	'pendingConsideration': "Ausstehende Bewertung",
	'paidOut': "Ausbezahlt",
	'rejected': "Abgelehnt",
	'payRequest': "Abhebungen",
	'writeHowMuchYouWantToWithdraw': "Geben Sie an, wie viel Sie abheben möchten",
	'rejectPayment': "Zahlung ablehnen",
	'paymentRejectingReason': "Grund für die Ablehnung der Zahlung",
	'currentBalance': "Aktuelles Guthaben",
	'withdraw': "Zurückziehen",
	'rejectSuccessfully': "Erfolgreich abgelehnt",
	'idTransaction': "Transaktions-ID",
	'sum': "Summe",
	'paymentSystem': "Bezahlsystem",
	'paymentRequests': "Auszahlungsanfragen",
	'paymentsHistory': "Zahlungshistorie",
	'user': "Benutzer",
	'rejectedPayments': "Abgelehnte Zahlungen",
	'addWorkType': "Jobtyp hinzufügen",
	'responseText': "Antworttext",
	'addAnswer': "Fügen Sie eine Antwort hinzu",
	'ago': "zurück",
	'month(1)': "Monat",
	'month(2-5)': "Monate",
	'month(6-0': "Monate",
	'more': "Mehr",
	'lessThanMonth': "Weniger als ein Monat",
	'markAllAsRead': "Alles als gelesen markieren",
	'orders': "Aufträge",
	'techSupportShort': "Unterstützung",
	'exchangePageName': "Austausch",
	'tickets': "Aufträge",
	'statistics': "Statistiken",
	'finances': "Finanzen",
	'tasks': "Aufgaben",
	'clients': "Kunden",
	'managers': "Manager",
	'authors': "Autoren",
	'sites': "Websites",
	'workTypes': "Arbeitsarten",
	'templateAnswers': "Vorlagenantworten",
	'scheduledTasks': "Aufgaben",
	'all': "Alle",
	'notDone(many)': "Tatsächlich",
	'sort': "Sortierung",
	'tasksCalendar': "Aufgabenkalender",
	'languages': "Sprachen",
	'accessDenied': "Der Zugriff wird verweigert",
	'addPhoto': "Füge ein Foto hinzu",
	'male': "Mann",
	'female': "Frau",
	'searchByOrderName': "Suche mit Name",
	'addOrder': "Bestellung hinzufügen",
	'doYouWantToRejectOrder': "Sind Sie dabei, Ihre Bestellung zu stornieren",
	'yourPersonalManager': "Ihr persönlicher Manager",
	'requestAnotherManager': "Fordern Sie einen anderen Manager an",
	'writeReason': "Beschreiben Sie den Grund",
	'profileEditing': "Profilbearbeitung",
	'changePhoto': "Foto bearbeiten",
	'deletePhoto': "Foto löschen",
	'chatWithYourManager(p1)': "Chatten Sie mit Ihrem",
	'chatWithYourManager(p2)': "Manager",
	'chatByOrder': "Chat",
	'chatAuthorByOrder': "Chat-Autor",
	'chatWithManagerByOrder': "Chat-Manager",
	'search': "Suchen",
	'copywriter': "Autor",
	'admin': "Administrator",
	'successNotification': "Erfolgreich",
	'dangerNotification': "Aufmerksamkeit",
	'errorNotification': "Fehler",
	'fieldFilledIncorrect': "Das Feld ist falsch ausgefüllt",
	"trash": "Mülleimer",
	"titleDialogMoveTrash": "Bestellung verschieben nach ...",

	// --------------- Chat
	'chatTrekingOpensTimes': "Öffnungszeiten",
	'chatTrekingLastOpened': "Zuletzt geöffnet",

	// --------------- Bestellung
	'orderFailedFeeNotPaid': "Bestellung fehlgeschlagen – Kunde abgelehnt (Gebühr nicht bezahlt)",
	'orderFailedFeePartiallyFullyPaid': "Bestellung fehlgeschlagen – der Kunde lehnte ab (die Gebühr wurde teilweise/vollständig bezahlt)",
	'clientNotContacting': "Bestellung fehlgeschlagen – Kunde antwortet nicht",
	'spam': "Spam",
	'duplicate': "Duplikat",

	// --------------- V2
	'newMessagesCountDisplay': "Neu",
	'logout': "Hinausgehen",
	'russian': "Russisch",
	'german': "Deutsch",
	"sunday": "Sonntag",
	"monday": "Montag",
	"tuesday": "Dienstag",
	"wednesday": "Mittwoch",
	"thursday": "Donnerstag",
	"friday": "Freitag",
	"saturday": "Samstag",
	"sundayShort": "Sonntag",
	"mondayShort": "Montag",
	"tuesdayShort": "Dienstag",
	"wednesdayShort": "Mittwoch",
	"thursdayShort": "Donnerstag",
	"fridayShort": "Freitag",
	"saturdayShort": "Samstag",
	"january": "Januar",
	"february": "Februar",
	"march": "März",
	"april": "April",
	"may": "Mai",
	"june": "Juni",
	"july": "Juli",
	"august": "August",
	"september": "September",
	"october": "Oktober",
	"november": "November",
	"december": "Dezember",
	"januaryGenitive": "Januar",
	"februaryGenitive": "Februar",
	"marchGenitive": "März",
	"aprilGenitive": "April",
	"mayGenitive": "Mai",
	"juneGenitive": "Juni",
	"julyGenitive": "Juli",
	"augustGenitive": "August",
	"septemberGenitive": "September",
	"octoberGenitive": "Oktober",
	"novemberGenitive": "November",
	"decemberGenitive": "Dezember",
	// --------------- end V2

	// --------------- V3
	"newtonsLaw": "Newtonsches Gesetz",
	"topic": "Thema",
	"finished": "Vollendet",
	"stages": "Stufen",
	"confirmUploading": "Download bestätigen",
	"fileDeletedSuccessfully": "Datei erfolgreich gelöscht",
	"fileDeletionError": "Beim Versuch, eine Datei zu löschen, ist ein Fehler aufgetreten",
	"isConfirmingStage": "Die Etappe wird nun vom Manager bestätigt",
	"changeTemplateAnswer": "Vorlagenantwort bearbeiten",
	"pages": "{n} Seiten | {n} Seiten | {n} Seiten | {n} Seiten",
	"doYouWantToDeleteAuthorFromOrder": "Sie sind dabei, den Autor aus der Bestellung zu entfernen",
	"doYouWantToDeleteFile": "Sie sind dabei, eine Datei zu löschen",
	"youDeletedAuthorFromOrder": "Sie haben den Autor aus dieser Bestellung entfernt",
	"noDataAvailable": "Keine Daten gefunden",
	"secondsAgo": "0 Sekunden zuvor | {n} Sekunden zuvor | {n} Sekunden zuvor | {n} Sekunden zuvor",
	"minutesAgo": "0 Vor ein paar Minuten | {n} Vor ein paar Minuten | {n} Vor ein paar Minuten | {n} Vor ein paar Minuten",
	"hoursAgo": "0 Vor Stunden | {n} Vor Stunden | {n} Vor Stunden | {n} Vor Stunden",
	"daysAgo": "0 Vor Tagen | {n} Vor Tagen | {n} Vor Tagen | {n} Vor Tagen",
	"yearsAgo": "0 Jahre zuvor | {n} Jahre zuvor | {n} Jahre zuvor | {n} Jahre zuvor",
	"justNow": "Jetzt",
	// --------------- end V3

	"placeholderGlovalSearchOrderById": "Bestellsuche nach Nummer",
	"resultGlovalSearchOrderById": "Suchergebnisse für Bestellnummern",
	"textNoResultGlovalSearchOrderById": "Bestellung nicht im System gefunden № ",

	"txtBtnManagerGetOrder": "Bestellung annehmen",
	"titleModalAddNewManager": "Genehmigen Sie einen Manager?",
	"titleModalManagerGetOrder": "Bestellung annehmen",
	"promtModalAddNewManager": "Möchten Sie einen neuen Manager ernennen?",
	"promtModalManagerGetOrder": "Sie nehmen eine Bestellung an ",

	"txtBtnChatMarkAsRead": "als gelesen markieren",
	"notifySuccessChatMarkAsRead": "Dieser Chat ist als gelesen markiert!",

	"listTickets": {
		"idOrder": "№",
		"timeOrder": "Datum",
		"nameOrder": "Bestellname",
		"websiteOrder": "Webseite",
	},

	"exchange": {
		'name': 'Thema',
		'area': 'Artikel',
		'type': 'Typ',
		'page': 'Seiten',
		'stage': 'Stufen',
		'price': 'Preis',
		'price_junior_middle': "Preis für Junior/Middle",
		'price_senior': "Preis für Senioren",
		'deadline': 'Termin',
		'accept': 'Mit zur Arbeit nehmen',
		'decline': 'Ablehnen',
		'confirmAction': 'Aktion bestätigen',
		'confirmActionText': 'Sie sind dabei, diesen Auftrag anzunehmen.',
		'confirmActionTextFalse': 'Sie sind im Begriff, eine Einladung zu dieser Bestellung abzulehnen.',
		'confirmPopup': 'Bestätigen',
		'order': 'Befehl',
		'countStages': 'Anzahl der Stufen',
		'nameWork': 'Thema',
		'subject': 'Artikel',
		'typeWork': 'Art von Arbeit',
		'levelQuality': 'Qualitätslevel',
		'countPages': 'Seitenzahl',
		'attachFile': 'Angehängte Dokumente',
		'langWork': 'Ausführungssprache',
		'comment': 'Ein Kommentar',
		'getToWork': 'Fortfahren!',
		'filter': 'Filter',
		'searchToName': 'Suche mit Name',
		'level': 'Eben',
		'off': 'vom',
		'to': 'bis zu',
		'reset': 'Zurücksetzen',
		'inviteDecline': 'Einladung abgelehnt',
		'inviteDeclineText': 'Sie haben die Einladung erfolgreich abgelehnt. Sie können diese Bestellung immer noch beantragen, wenn Sie Ihre Meinung ändern.',
		'inviteAccept': 'Einladung angenommen',
		'inviteAcceptText': 'Danke, Sie können loslegen.',
		'requestSend': 'Antrag gesendet',
		'requestSendText': 'Vielen Dank, wir haben Ihre Anfrage erhalten. Der Manager wird es bald bestätigen. Bitte warten Sie',
		'success': 'Erfolgreich',
		'successText': 'Erfolgreich abgeschlossen',
		'deleteText': 'Erfolgreich entfernt',
		'acceptText': 'Erfolgreich hinzugefügt',
	},
	"stats": {
		"junior": 'Wirtschaft',
		"middle": 'Geschäft',
		"senior": 'Akademisch',
		"income": 'Einkommen',
		"total": 'Netz',
		"totalIncome": 'Einkommen',
		"privateIncome": 'Persönliches Einkommen',
		"sitesCount": 'Websites',
		"paidOrdersCount": 'Bezahlt',
		"waitingOrdersCount": 'baumeln',
		"graphIncome": 'Persönliches Einkommen',
		"graphOrders": 'Aufträge',
		"graphIncomeGlobal": 'Einkommen',
		"graphOrdersPaid": '"Hängende Befehle',
		"completeOrder": 'Vollendet',
		"successOrder": 'Erfolg',
		"today": 'Heute',
		"yesterday": 'Gestern',
		"currentWeek": 'Diese Woche',
		"prevWeek": 'Letzte Woche',
		"current_month": 'Aktueller Monat',
		"last_month": 'Im vergangenen Monat',
		"last_three_month": '3 Monate',
		"last_six_month": 'Ein halbes Jahr',
		"last_year": 'Jahr',
		"all_time": 'Während dieser ganzen Zeit',
		"active": "Aktive Bestellungen",
		"clientsCount": 'Kunden',
		"authorsCount": 'Autoren',
		"managersCount": 'Manager',
		"incomeTotal": 'Grob',
		"incomeClean": 'Netz',
		"ordersCount": 'Bestellungen insgesamt',
		"graphUsers": 'Neue Nutzer',
		"graphQualityLevels": 'Bestellungen nach Qualitätsstufen',
		"graphSubjects": 'Artikelbestellungen',
		"graphAdminIncome": 'Gewinnquote',
		"newPaidTickets": 'Aufträge',
		"completedTickets": 'Status abgeschlossener Bestellungen',
		"conversion": 'Wandlung',
		"date": 'Datum',
		"manager": 'Manager',
		"clients": 'Kunden',
		"authors": 'Autoren',
		"mangers": 'Manager',
		"graph_new": 'neue Bestellungen',
		"paid": 'Bezahlte Bestellungen',
		"completed": 'Erledigt',
		"failed": 'Fehlgeschlagen',
	},
};